/* eslint-disable id-length */
export const MODULE_NAMES = {
  USER_ROLE: 'user-roles-service', // place service name as value of casbin's key
  MASTER_DELIVERY_ROLE: 'masters:delivery:role',
  MASTER_TRAINING_SKILL: 'masters:training:skill',
  MASTER_TRAINING_CERTIFICATION: 'masters:training:certification',
  CERTIFICATION_TARGET: 'certifications:target',
  CONFIGURATION_USER: 'configuration:users',
  CONFIGURATION_SKILL: 'configuration:skills',
  CERTIFICATION_OVERVIEW: 'certifications:overview',
  CERTIFICATION_MAP: 'certifications:map',
  PERMISSION: 'permissions',
  EMPLOYEE_ONBOARDING: 'employee-profile:onboarding',
  EMPLOYEE_TRAINING: 'employee-profile:trainings-and-assessments',
  EMPLOYEE_PROJECTS: 'employee-profile:projects',
  EMPLOYEE_PERFORMANCE: 'employee-profile:performance',
  EMPLOYEE_ACHIEVEMENTS: 'employee-profile:achievements',
  CONFIGURATION_MANAGE_KPI: 'configuration:manage-kpi',
  MASTER_PERFORMANCE_PERIOD: 'masters:performance:declare-performance-period',
  MASTER_REMARKS: 'masters:performance:declare-remarks',
  DEAL_TRANSITION_WORKFLOW: 'deal-transition:custom-workflow',
  DEAL_TRANSITION_DASHBOARD: 'deal-transition:dashboard',
  DEAL_TRANSITION_REVENUE: 'deal-transition:revenue',
  DEAL_TRANSITION_SLO: 'deal-transition:slo',
  DEAL_TRANSITION_STAFFING: 'deal-transition:staffing-projections',
  MASTER_DEAL_STATUS: 'masters:deal-transition:deal-status',
  MASTER_DEAL_ROLE: 'masters:deal-transition:deal-role',
  MASTER_DEAL_EFFORTS: 'masters:deal-transition:efforts',
  MASTER_TRAINING_CERT_CATEGORY: 'masters:training:certification-category',
  MASTER_COST_MASTER: 'masters:deal-transition:cost-master',
  CONFIGURATION_LEAVE_UPLOAD: 'configuration:data-upload:leave-upload',
  CONFIGURATION_EFFORT_UPLOAD: 'configuration:data-upload:effort-upload',
  CONFIGURATION_FILE_UPLOAD: 'configuration:data-upload:file-upload',
  CONFIGURATION_UPLOAD_CONFIG: 'configuration:upload-config',
  CONFIGURATION_DATE_CONFIG: 'configuration:date-configuration',
  MASTER_DEAL_PARAMETERS: 'masters:deal-transition:parameters',
  MASTER_STAFFAUG_REQUIREMENT_STATUS:
    'masters:staff-aug-status:requirement-status',
  MASTER_STAFFAUG_CLIENT_INTERVIEW:
    'masters:staff-aug-status:client-interview-status',
  MASTER_STAFFAUG_LOST_DROPPED_STATUS:
    'masters:staff-aug-status:lost-dropped-status',
  MIS_COLLECTION_REPORT: 'mis:collection-report',
  MIS_RESELLER_REPORT: 'mis:reseller-report',
  MIS_HEALTH_CHECK: 'mis:health-check:pmo',
  MIS_STAFF_AUG_REPORT: 'mis:staff-augmentation-report',
  STAFF_AUG_REQ_STATUS: 'staff-augmentation:requirement-status',
  DEAL_TRANSITION_COMMERCIAL_PROJECTIONS:
    'deal-transition:commercial-projections',
  DEAL_TRANSITION_DETAIL_COMMERCIALS: 'deal-transition:deal-detail-commercials',
  DEAL_TRANSITION_EFFORT_ESTIMATION: 'deal-transition:deal-effort-estimation',
  DEAL_TRANSITION_SLA_OVERRIDE: 'deal-transition:deal-sla-override',
  DEAL_TRANSITION_DEAL_ASSIGN: 'deal-transition:deal-assign',
  DEAL_TRANSITION_DEAL_STATUS_CHANGE: 'deal-transition:deal-status-change',
  STAFF_AUG_PROJECT_RESOURCING: 'staff-augmentation:project-resourcing',
  DELIVERY_PROJECT_OVERVIEW: 'delivery:project-overview:project-details',
  DELIVERY_ALLOCATION_DETAILS_VIEW:
    'delivery:project-overview:allocation-details-view',
  TECH_SESSION: 'organization-contribution:tech-session',
  TECH_SESSION_CALENDAR:
    'organization-contribution:tech-session:tech-session-calender',
  TECH_SESSION_NEW_REQUEST:
    'organization-contribution:tech-session:tech-session-user',
  TECH_SESSION_RECEIVED_REQUEST:
    'organization-contribution:tech-session:tech-session-receive-request',
  ORGANIZATION_BLOGS: 'organization-contribution:blogs',
  MIS_HEALTH_CHECK_PMO: 'mis:health-check:pmo',
  DELIVERY_PROJECT_OVERVIEW_lAST_MONTH:
    'delivery:project-overview:project-logged-effort-percentage-view',
  DEAL_TRANSITION_DEAL_EFFORT_APPROVAL:
    'deal-transition:deal-approval:deal-effort-approval',
  DEAL_TRANSITION_DEAL_FINANCIAL_APPROVAL:
    'deal-transition:deal-approval:deal-financial-approval',
  DELIVERY_PROJECT_OVERVIEW_CSAT: 'delivery:project-overview:csat',
  DELIVERY_PROJECT_OVERVIEW_AGM: 'delivery:project-overview:agm',
  DELIVERY_PROJECT_OVERVIEW_EGM: 'delivery:project-overview:egm',
  DELIVERY_PROJECT_OVERVIEW_SGM: 'delivery:project-overview:sgm',
  DELIVERY_AUDIT_SCORE: 'delivery:project-overview:audit-score',
  DELIVERY_RAG_STATUS: 'delivery:project-overview:rag-status',
  DELIVERY_PROJECT_PROGRESS: 'delivery:project-overview:project-progress',
  MIS_ESTIMATION_VS_ACTUAL_MIS: 'mis:estimation-vs-actual-mis',
  FINANCE_MILESTONE_INVOICE_AMOUNT_VIEW:
    'finance:milestone:milestone-invoice-amount-view',
  PROJECT_CHANGE_REQUEST: 'project:change-request',
  NOTIFICATIONS: 'notifications',
};
